module.exports = __webpack_public_path__ + "static/media/accessory8.d0da69bf.webp";